import { memo } from "react";
import { useUtilityPreference, UtilityChoice } from "@/hooks/useUtilityPreference";
import { Zap } from "lucide-react";

const OPTIONS: UtilityChoice[] = ["SCE", "PG&E", "SDG&E", "Other"];

/**
 * First-interaction utility selector. Localizes hero copy + calculator instantly.
 * Single tap, mobile-first (48px+ targets).
 */
const HeroUtilitySelector = () => {
  const { utility, setUtility } = useUtilityPreference();

  return (
    <div className="mb-5 rounded-xl border border-secondary/30 bg-secondary/5 p-3 md:p-4">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-foreground">
        <Zap className="h-4 w-4 text-secondary" aria-hidden="true" />
        <span>Who's your utility?</span>
        <span className="text-xs font-normal text-muted-foreground">
          (We'll localize your savings)
        </span>
      </div>
      <div className="grid grid-cols-4 gap-2">
        {OPTIONS.map((opt) => {
          const active = utility === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => setUtility(opt)}
              aria-pressed={active}
              className={`min-h-[48px] rounded-lg border text-sm font-semibold transition-all ${
                active
                  ? "border-secondary bg-secondary text-secondary-foreground shadow-md"
                  : "border-border bg-background text-foreground hover:border-secondary/60 hover:bg-secondary/10"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default memo(HeroUtilitySelector);
